import { Controller } from "@hotwired/stimulus"

// A guide's sections as tabs on one page: one section shows at a time, and each has its own anchor
// (#daily-picks, #map…) so a link can open it. Choosing a tab once the tabs have stuck under the
// header brings the section's top up to them; above that, the page stays where it is.
export default class extends Controller {
  static targets = ["bar", "tab", "panel"]

  connect() {
    this.onHashChange = () => this.showHash(true)
    window.addEventListener("hashchange", this.onHashChange)
    this.showHash(true)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange)
  }

  select(event) {
    event.preventDefault()
    const anchor = event.currentTarget.dataset.anchor
    const stuck = this.barTarget.getBoundingClientRect().top <= this.stickyTop() + 1
    this.show(anchor)
    history.replaceState(history.state, "", `#${anchor}`)
    if (stuck) this.scrollToPanel(anchor)
  }

  showHash(scroll) {
    const anchor = window.location.hash.slice(1)
    const panel = this.panelTargets.find(element => element.id === anchor)
    if (!panel) return

    this.show(anchor)
    if (scroll) requestAnimationFrame(() => this.scrollToPanel(anchor))
  }

  show(anchor) {
    this.panelTargets.forEach(panel => { panel.hidden = panel.id !== anchor })
    this.tabTargets.forEach(tab => tab.setAttribute("aria-current", String(tab.dataset.anchor === anchor)))
    this.tabTargets.find(tab => tab.dataset.anchor === anchor)?.scrollIntoView({ block: "nearest", inline: "nearest" })
  }

  // The tabs sit at the top of the section, stuck under the header
  scrollToPanel(anchor) {
    const panel = this.panelTargets.find(element => element.id === anchor)
    if (!panel) return

    const top = panel.getBoundingClientRect().top + window.scrollY - this.stickyTop() - this.barTarget.offsetHeight
    window.scrollTo({ top: Math.max(top, 0), behavior: "instant" })
  }

  stickyTop() {
    return parseFloat(getComputedStyle(this.barTarget).top) || 0
  }
}
